"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9926],{

/***/ 79926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Overview; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(52261);
;// CONCATENATED MODULE: ./containers/CareersPage/Overview/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nwidth: 100%;\n/* height: 650px; */\nbackground-color: white;\npadding-top: 50px;\npadding-left: 100px;\ndisplay: flex;\n\n@media only screen and (max-width: 560px) {\n  display: inline-block;\n  padding: 20px;\n  \n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\nflex: 1;\nheight: 45%;\nwidth: 35%;\n/* border: 1px solid black; */\ncolor: black;\npadding-right: 60px;\n\n@media only screen and (max-width: 560px) {\n  padding: 25px 0px 0px 0px;\n  width: 100%;\n  text-align: center;\n}\n \n.title{\n   font-family: "Montserrat";\n   font-weight: bold;\n   padding-bottom: 10px;\n }\n\n .text-overview1 {\n  font-family: "Helvetica";\n  font-size: 15px;\n  padding-bottom: 30px;\n\n  /* &>span {\n    font-weight: bold;\n  } */\n }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\npadding-right: 0px;\n\n .text-overview1.bullet {\n  margin-bottom: 5px; \n  padding-bottom: 0px;\n\n  &.last {\n    margin-bottom: 40px;\n  }\n\n }\n\n .last {\n     padding-bottom: 40px;\n   }\n\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var MainSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-16f27d1-0"
})(_templateObject());
var CompanyOverviewAndCulture = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-16f27d1-1"
})(_templateObject1());
var EmploymentOppAndBen = (0,styled_components_browser_esm/* default */.ZP)(CompanyOverviewAndCulture).withConfig({
    componentId: "sc-16f27d1-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./containers/CareersPage/Overview/index.js



function OverviewSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyOverviewAndCulture, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title",
                            children: "COMPANY OVERVIEW"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-overview1",
                            children: "For over 35 years Classy Closets has provided our customers with high-quality custom closets and an array of other custom storage solutions. We understand that each client and each home is truly unique. The perfect closet solutions aren’t one size fits all, and we are passionate about creating the ultimate organizational solutions from luxury master closets to garage cabinets and wall beds.."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-overview1",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "The Classy Closets Difference: "
                                }),
                                " Professional Designers, Uncompromising Quality, Expansive Selection, Unparalleled Service."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title",
                            children: "COMPANY CULTURE"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-overview1",
                            children: "We work with each of our clients to create an individualized, unique closet or home storage design that is both beautiful and functional. With Classy Closets there’s no need to sacrifice form for practicality—we deliver both! Offering several styles, materials, finishes, hardware, and accessories to create the perfect closet solution for everyone is our specialty."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-overview1",
                            children: "If you’d like to be a part of our team that makes this unique experience possible, we’d love to hear from you. We are actively seeking individuals that deliver the Classy Closets Experience as part of our installation and manufacturing teams."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmploymentOppAndBen, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title",
                            children: "EMPLOYMENT OPPORTUNITIES"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-overview1 bullet",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-hidden": true,
                                    className: "fas fa-minus"
                                }),
                                " Full-time employment"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-overview1 bullet",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-hidden": true,
                                    className: "fas fa-minus"
                                }),
                                " Learn a Trade Skill"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-overview1 last",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-hidden": true,
                                    className: "fas fa-minus"
                                }),
                                " Opportunities for Advancement"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "title",
                            children: "COMPANY BENEFITS "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-overview1",
                            children: "Our large sales teams, production staff, and installation crews work together to grow and provide a stable, productive and fun workplace."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-overview1 bullet",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "Benefits Include:"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-overview1 bullet",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-hidden": true,
                                    className: "fas fa-minus"
                                }),
                                " Medical, dental, and vision insurance after 60 days of employment"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-overview1 bullet",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-hidden": true,
                                    className: "fas fa-minus"
                                }),
                                " PTO and Sick Pay after 60 days."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-overview1 bullet",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-hidden": true,
                                    className: "fas fa-minus"
                                }),
                                " 401(k) program"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-overview1 bullet last",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-hidden": true,
                                    className: "fas fa-minus"
                                }),
                                " Paid holidays"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-overview1",
                            children: "We provide on the job training programs to learn this unique skilled trade, tools necessary for installation, fuel for your vehicle when you become a lead installer, programs to help you purchase a work vehicle, along with a great place to work"
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Overview = (OverviewSection);


/***/ })

}]);